import { ApiEndpointSpecification } from './types';
import { HttpMethod } from '../http-request';
import * as Helpers from '../api-request-helpers';
import * as Types from '../types';

type StarfishGatewayDeviceRegistrationEndpointSpecification = ApiEndpointSpecification;
export const StarfishGatewayDeviceRegistrationEndpointSpecification: StarfishGatewayDeviceRegistrationEndpointSpecification = {
    url: '/api/device/registration/gateway',
    method: HttpMethod.POST,
    requestParamsSchemaName: 'StarfishGatewayDeviceRegistrationRequestParams',
    requestBodySchemaName: 'StarfishGatewayDeviceRegistrationRequestBody',
    okResponseSchemaName: 'StarfishGatewayDeviceRegistrationOkResponse',
    notOkResponseSchemaName: 'GenericNotOkResponse',
    authenticated: true,
    version: 3,
};  

export const invokeStarfishGatewayDeviceRegistration = Helpers.makeApiRequestFn<
    Types.StarfishGatewayDeviceRegistrationRequestParams,
    Types.StarfishGatewayDeviceRegistrationRequestBody,
    Types.StarfishGatewayDeviceRegistrationOkResponse
>(StarfishGatewayDeviceRegistrationEndpointSpecification);
